import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1a7ab14e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1a7ab14e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7ab14e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a7ab14e')) {
      api.createRecord('1a7ab14e', component.options)
    } else {
      api.reload('1a7ab14e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1a7ab14e&scoped=true", function () {
      api.rerender('1a7ab14e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/switchStatus/index.vue"
export default component.exports